//@flow
import React from 'react';
import { themr } from 'react-css-themr';
import { Select } from 'common/components/core/select';
import { translate } from 'react-i18next';
import { SlotType } from 'common/enums/SlotEnum';
import defaultTheme from './SlotsSelector.scss';

type SlotsSelectorProps = {
    t: (string, ?Object) => string,
    defaultSlots?: ?Array<any>,
    theme: Object,
    type: string,
    timeSlots: Array<any>,
    selectedDays: Array<string>,
    onSingleSlotChange: Function,
    onSingleSlotDelete: Function,
    onAddSlot: Function,
    createDefaultSlot: Function,
    onCopySlotToAll: Function,
    updateSelectedDays: Function,
    onSlotTypeChange: Function,
    getShouldUncheckOnRemove: Function,
    getIsTimeSlotEmpty: Function
};

const slotsSelectorFactory = ({
    MultiDayWeekSlotsSelector,
    EverydaySlotsSelector,
    options = {
        undecorated: false
    }
}) => {
    class SlotsSelector extends React.PureComponent<SlotsSelectorProps> {
        constructor(props) {
            super(props);
            this.slotOptions = Object.values(SlotType).map(key => {
                return {
                    value: SlotType[key],
                    label: props.t(`slotProperties.type.${key}`)
                };
            });
        }
        renderEveryDayDateSelectors() {
            const {
                theme,
                t,
                timeSlots,
                onSingleSlotChange,
                onSingleSlotDelete,
                onAddSlot,
                createDefaultSlot,
                ...others
            } = this.props;
            return (
                <EverydaySlotsSelector
                    {...others}
                    onSlotChange={onSingleSlotChange}
                    onDeleteSlot={onSingleSlotDelete}
                    onAddSlot={onAddSlot}
                    createDefaultSlot={createDefaultSlot}
                    timeSlots={timeSlots}
                    theme={theme}
                    t={t}
                />
            );
        }

        renderMultiDayDateSelectors() {
            const {
                theme,
                t,
                timeSlots,
                selectedDays,
                onSingleSlotChange,
                onSingleSlotDelete,
                onAddSlot,
                onCopySlotToAll,
                updateSelectedDays,
                getShouldUncheckOnRemove,
                getIsTimeSlotEmpty,
                ...others
            } = this.props;
            return (
                <MultiDayWeekSlotsSelector
                    {...others}
                    theme={theme}
                    t={t}
                    timeSlots={timeSlots}
                    selectedDays={selectedDays}
                    onChange={onSingleSlotChange}
                    onDelete={onSingleSlotDelete}
                    onAddSlot={onAddSlot}
                    onCopyToAllClick={onCopySlotToAll}
                    onToggleSelection={updateSelectedDays}
                    getShouldUncheckOnRemove={getShouldUncheckOnRemove}
                    getIsTimeSlotEmpty={getIsTimeSlotEmpty}
                />
            );
        }

        render() {
            const { theme, type, onSlotTypeChange, children } = this.props;
            return (
                <div className={theme.slotsWrap}>
                    <Select
                        className={theme.typeSelector}
                        options={this.slotOptions}
                        value={type}
                        onChange={onSlotTypeChange}
                        isSearchable={false}
                        isClearable={false}
                    />
                    {type === SlotType.EVERYDAY
                        ? this.renderEveryDayDateSelectors()
                        : this.renderMultiDayDateSelectors()}
                    {children}
                </div>
            );
        }
    }
    return options.undecorated
        ? SlotsSelector
        : translate('entityManagement')(
              themr('SlotsSelector', defaultTheme)(SlotsSelector)
          );
};

export { slotsSelectorFactory };
export default slotsSelectorFactory;
